import { render, staticRenderFns } from "./IpoResultTransferRow.vue?vue&type=template&id=6a9e6e9a&scoped=true"
import script from "./IpoResultTransferRow.vue?vue&type=script&lang=js"
export * from "./IpoResultTransferRow.vue?vue&type=script&lang=js"
import style0 from "./IpoResultTransferRow.vue?vue&type=style&index=0&id=6a9e6e9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9e6e9a",
  null
  
)

export default component.exports